import { ServiceUnitType } from '@/types';
import { Core, SERVICE_UNIT_TYPES } from '../Core';

class ServiceUnitTypes extends Core {
  getServiceUnitTypes = async () =>
    this.get<ServiceUnitType[]>(SERVICE_UNIT_TYPES());
}

export const serviceUnitTypes = new ServiceUnitTypes();
